import { render, staticRenderFns } from "./BaseQuestionsIcon.vue?vue&type=template&id=cb65e0d8"
import script from "./BaseQuestionsIcon.vue?vue&type=script&lang=js"
export * from "./BaseQuestionsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports